import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

const template = `
    <p [innerHTML]="'PAGE_NOT_FOUND_TEXT' | translate"></p>
`;

@Component({
    selector: 'app-page-not-found',
    template: template,
    standalone: true,
    imports: [TranslateModule],
})
export class PageNotFoundComponent {
    constructor() {}
}
